<template>
    <q-page class="flex flex-center">
        <div class="row content-center justify-center q-pa-md">

            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 q-pa-md" style="width:400px">
                <h1 class="Page-Title">Contact Form</h1>
                <q-form @submit="formSubmit" @reset="formReset" ref="contactForm" class="q-ma-md">
                    <q-input
                            ref="name"
                            class="full-width"
                            v-model="name"
                            label="Your name *"
                            lazy-rules :rules="[
                                val => val && val.length > 0 || 'Please type your name'
                            ]"
                    />
                    <q-input
                            ref="email"
                            class="full-width"
                            v-model="email"
                            label="Your e-mail address *"
                            lazy-rules :rules="[
                                val => val && val.length > 0 || 'Please type your email adress',
                                val => val.includes('@') || 'Not a valid email address, include an @',
                                val => val.includes('.') || 'Not a valid email address, include an .'
                            ]"
                    />

                    <q-input
                            ref="message"
                            class="full-width"
                            v-model="message"
                            label="Your message *"
                            lazy-rules :rules="[
                                val => val && val.length > 0 || 'Your message is required'
                            ]"
                            type="textarea"
                    />



                    <div class="q-pa-md text-center">
                        <q-btn label="Submit" type="submit" color="secondary" text-color="primary"/>
                        <q-btn label="Reset" type="reset" color="primary" flat class="q-ml-sm"/>
                    </div>
                </q-form>
            </div>

            <div class="col-grow q-pa-md" style="">
                <h1 class="Page-Title">Info</h1>
                <p class="q-ma-md">
                    The Black Cat Company CommV.<br>
                    Terweststraat 28<br>
                    9180 Moerbeke-Waas<br>
                    Belgium
                </p>
                <p class="q-ma-md"><strong>VAT Nr</strong>: BE0697.884.415</p>
            </div>
        </div>
    </q-page>
</template>

<script>
    export default {
        name: "Contact",
        data() {
            return {
                name: null,
                email: null,
                message: null
            }
        },
        methods: {
            formSubmit() {
                var self = this
                var newDate = new Date();
                const submitUri = "https://formcarry.com/s/4K0eMPPeazO";
                const data = {
                    "email": this.email,
                    "name": this.name,
                    "message": this.message,
                    "submittedOn": newDate.toDateString()
                };

                this.$http.post(submitUri, data, {headers: {'Accept': 'application/json'}})
                    .then((response) => {
                        self.$q.notify({
                            color: response.data.status === "success" ? "positive" : "accent",
                            message: "Thank you for contacting us, "+this.name+". You will be contacted shortly",
                            icon: 'thumb_up'
                        })
                    })
                    .catch((error) => {
                       self.$q.notify({
                           message: "Something went wrong. " + error,
                           color: 'negative',
                           textColor: 'white',
                           icon: 'thumb_down'
                       })
                    })

            },
            formReset() {
                this.name = null;
                this.email = null;
                this.message = null;
                this.$refs.contactForm.resetValidation();
                this.$q.notify({
                    message: 'Reset all value\'s on the form'
                })
            }
        }
    }
</script>

<style scoped>

</style>